// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cf224f84","160":"a2dee491","208":"139b304e","293":"f9172286","516":"eeab0326","519":"877892bf","917":"344dc1a0","946":"1b4c7ec2"}[chunkId] + ".chunk.js";
};